export function getTagUserIdList(contents) {
  let div = document.createElement('div');
  div.style.visibility = 'hidden';
  div.id = 'replaceHtml';
  document.body.appendChild(div);
  const replaceHtml = document.getElementById('replaceHtml')!;

  replaceHtml.innerHTML = contents;
  const getMentionEls = replaceHtml.querySelectorAll('[data-id]');
  let idList: string[] = [];
  for (var i in getMentionEls)
    if (getMentionEls.hasOwnProperty(i)) {
      const id = getMentionEls[i].getAttribute('data-id') || '';
      idList.push(id);
    }
  div.remove();
  return idList;
}
